module.exports = __webpack_public_path__ + "img/apidays-ppt-5.b52ff2c1.png";